import { ADMIN_CONFIG } from '@/constants/config';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';

const adminApi = axios.create({
  baseURL: ADMIN_CONFIG.api.baseUrl,
  timeout: ADMIN_CONFIG.api.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

tokenManager.setupInterceptors(adminApi);

/**
 * Unwrap NestJS TransformInterceptor response.
 * The API wraps responses as { data: <payload>, meta: { timestamp, path, statusCode } }
 * But paginated responses are { data: [...], pagination: {...} } (no meta wrapper).
 * This interceptor detects and unwraps only the meta-wrapped responses.
 */
adminApi.interceptors.response.use((response) => {
  const d = response.data;
  // If response has { data, meta } (TransformInterceptor wrapper), unwrap
  if (d && typeof d === 'object' && 'meta' in d && 'data' in d) {
    response.data = d.data;
  }
  return response;
});

export { adminApi };
